import { randomNumberRange } from "./funcs"
import _mock from "./_mock"

export const StepFourDataMock = {
    "title": randomNumberRange(100, 300) + " Lotes",
    "estimated_vgv": 0,
    "square_meter_value": randomNumberRange(100, 300),
    "profit_margin": randomNumberRange(0, 100),
    "estimated_cost": randomNumberRange(100, 1000),
    "urbia_score": randomNumberRange(1, 3),
    "area_use": [
      {
        "name": 'Lotes',
        "value": 25,
        "color": '#1890FF'
      },
      {
        "name": 'Verde',
        "value": 25,
        "color": '#54D62C'
      },
      {
        "name": 'Inst.',
        "value": 40,
        "color": '#FFC107'
      },
      {
        "name": 'Arruamento',
        "value": 10,
        "color": '#FF4842'
      }
    ],
    "occupation_data": {
      "average_lot_area": randomNumberRange(100, 500),
      "number_of_lots": randomNumberRange(100, 500),
      "front_size_lots": randomNumberRange(100, 500),
      "raw_area": randomNumberRange(100, 500),
      "restrictions": randomNumberRange(100, 500),
      "liquid_area": randomNumberRange(100, 500) + 'm²',
      "green_area": {
        "square_meter": randomNumberRange(100, 500),
        "percentage_on_liquid_area": randomNumberRange(0, 100)
      },
      "institutional_area": {
        "square_meter": randomNumberRange(100, 500),
        "percentage_on_liquid_area": randomNumberRange(0, 100)
      },
      "channels_lakes": {
        "square_meter": randomNumberRange(100, 500),
        "percentage_on_liquid_area": randomNumberRange(0, 100)
      },
      "road_system": {
        "square_meter": randomNumberRange(100, 500),
        "percentage_on_liquid_area": randomNumberRange(0, 100)
      },
      "salable_area": {
        "square_meter": randomNumberRange(100, 500),
        "percentage_on_liquid_area": randomNumberRange(0, 100)
      }
    },
    "indicators": {
      "front_size_total": randomNumberRange(100, 500),
      "road_axes_total": randomNumberRange(100, 500),
      "cart_area": randomNumberRange(100, 500),
      "area_ratio": randomNumberRange(0, 100),
      "front_size_ratio": randomNumberRange(0, 100),
      "cart_area_ratio": randomNumberRange(0, 100)
    },
    "lots_data": [
      {
        "area": {
          "color": "#00B13C",
          "description": "140 a 170"
        },
        "number_of_lots": randomNumberRange(100, 500),
        "percentage_of_total": randomNumberRange(0, 100)
      },
      {
        "area": {
          "color": "#EAFF00",
          "description": "170 a 200"
        },
        "number_of_lots": randomNumberRange(100, 500),
        "percentage_of_total": randomNumberRange(0, 100)
      }
    ]
}

export const StepFourDataInitial = {
  "title": "",
  "estimated_vgv": 0,
  "square_meter_value": 0,
  "profit_margin": 0,
  "estimated_cost": 0,
  "urbia_score": 0,
  "area_use": [
  ],
  "occupation_data": {
    "average_lot_area": 0,
    "number_of_lots": 0,
    "front_size_lots": 0,
    "raw_area": 0,
    "restrictions": 0,
    "liquid_area": 0,
    "green_area": {
      "square_meter": 0,
      "percentage_on_liquid_area": 0
    },
    "institutional_area": {
      "square_meter": 0,
      "percentage_on_liquid_area": 0
    },
    "channels_lakes": {
      "square_meter": 0,
      "percentage_on_liquid_area": 0
    },
    "road_system": {
      "square_meter": 0,
      "percentage_on_liquid_area": 0
    },
    "salable_area": {
      "square_meter": 0,
      "percentage_on_liquid_area": 0
    }
  },
  "indicators": {
    "front_size_total": 0,
    "road_axes_total": 0,
    "cart_area": 0,
    "area_ratio": 0,
    "front_size_ratio": 0,
    "cart_area_ratio": 0
  },
  "lots_data": [
  ]
}

export const StepThreeDataInitial = {
  "type": "loteamento",
  "enterprise_standard": "B",
  "legalCondition": "multiFamily",
  // "gleba_size_ha": 0,
  "glebaValue": "",
  "otherInfos": "",
  "resLot_front_size": 10,
  "resLot_min_area": 250,
  "resLot_lot_depth": 25,
  
  "resCorner_front_size": 10,
  "resCorner_min_area": 250,
  "resCorner_lot_depth": 25,
  
  "commercialLot_front_size": 10,
  "commercialLot_min_area": 250,
  "commercialLot_lot_depth": 25,
  
  "commercialCorner_front_size": 10,
  "commercialCorner_min_area": 250,
  "commercialCorner_lot_depth": 25,
  
  "block_lot_depth": 10,
  "block_length": 50,
  
  "donate_green_area": 10,
  "donate_institutional_area": 5,
  "donate_total": 5,
  "donate_decliv": 5,
  "donate_appAv": 5,
  "donate_minRadius": 5,
  "donate_reservAv": 5,
  "donate_minRadiusAv": 5,
  
  "local_range": 12,
  "local_sidewalk": 2.5,
  "collector_range": 14,
  "collector_sidewalk": 3.5,
  "arterial_range": 12,
  "areterial_sidewalk": 3.5,

  
  "aquisition": "no",
  "litorianReg": "no",
  "efluentTreatment": "no",
  "pavimentation": "block",
  "predomTopo": "waved",
  "predomGroud": "clayish",
  "rainRelease": "next",
  "architecture": "no",
  "reservatory": "no",
  "permut": 5,
  "vgvFees": 5,
  "sellPriceMeter": 5,
  "brokerage": 5,
}